import './HorizontalRule.scss';

export const HorizontalRule = () => {
  return (
    <hr className="horizontal-rule" />
  )
}
